export default __webpack_public_path__ + "static/AICPA-30d6e39dd6b5128528521a517a5c67a0.png";